import { Base } from "ui/Scripts/source/framework/base";
import { FrontToDoItem, IFrontToDoItem } from "./frontToDoItem";
import { ModifiedRecordListItem } from "./modifiedRecordListItem";
import { DatabaseRecordType } from "ui/Scripts/source/models/enums";

export interface IFrontToDoItemGroup {
    recordType: number;
    items: IFrontToDoItem[];

    getRecordTypeIntraUrl(): string;
    getRecordTypeTitle(): string;
}

export class FrontToDoItemGroup implements IFrontToDoItemGroup {
    recordType: number;
    items: FrontToDoItem[];

    constructor();
    constructor(obj: IFrontToDoItemGroup);
    constructor(obj?: any) {
        this.recordType = obj && obj.recordType || 0;
        this.items = Base.getTypedArray(obj ? obj.items : null, FrontToDoItem);
    }

    getRecordTypeIntraUrl(): string {
        return ModifiedRecordListItem.getIntraUrlByRecordType(this.recordType) + (this.recordType === DatabaseRecordType.Event || this.recordType === DatabaseRecordType.WhistleBlow ? "/list" : "");
    }

    getRecordTypeTitle(): string {
        return ModifiedRecordListItem.getPluralTitleByRecordType(this.recordType);
    }
}